import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/self.css'
import './assets/css/font-awesome.min.css'
import global from './Global.js'
import VueResource from 'vue-resource'

Vue.prototype.GLOBAL = global;
Vue.config.productionTip = false;

Vue.use(VueResource)

router.beforeEach((to, from, next) => {
	if (window.localStorage.getItem('auth') != 'success') {
		next("/error");
	} else {
		next();
	}
})


Vue.http.interceptors.push((request, next) => {
	request.headers.set('token', window.localStorage.getItem('token')); //setting request.headers
	next((response) => {
		return response
	})

})

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
